<template>
    <div class="index">
        <div class="banner" v-if="homeCarousels.length">
            <carousel-3d 
                @touchstart.native="touchStart"
                @touchend.native="touchEnd"
                @before-slide-change="onBeforeSlideChange"
                :border="0"
                :perspective="0"
                :space="500"
                :display="5"
                :dir="'ltr'"
                :autoplay="true"
                :autoplayTimeout="4000"
                :width="BannerCarouselStyle.Width"
                :height="BannerCarouselStyle.Height"
                :disable3d="disable3d">
                <slide v-for="(slide, i) in homeCarousels" :index="i" :key="i">
                    <a :href="slide.ImageLink" target="_blank" v-if="i == currentSlideIndex">
                        <div class="img_box">
                            <img :src="slide.src" />
                        </div>
                    </a>
                    <div class="img_box" v-else>
                        <img :src="slide.src" />
                    </div>
                </slide>
            </carousel-3d>
        </div>
        <div class="container">
            <div v-if="swiperDom.length" class="collection posr">
                <h2>{{ h2title.featured }}</h2>
                <swiper :options="swiperOption">
                    <swiper-slide v-for="(item, index) in swiperDom" v-bind:key="index">
                        <ProductItem :product="item" :isSingleRow="true" />
                    </swiper-slide>
                </swiper>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
                <div class="swiper-pagination" slot="pagination"></div>
            </div>
            <div class="products collection posr">
                <ProductItemBox v-if="productShelves.length" :products="productShelves" :products_title="h2title.shelves" :to="{ name: 'shelves' }"/>
                <ProductItemBox v-if="productPopular.length" :products="productPopular" :products_title="h2title.popular" :to="{ name: 'popular' }" />
                <ProductItemBox v-if="productTrailer.length" :products="productTrailer" :products_title="h2title.trailer" :to="{ name: 'trailer' }" :isBackgroundStyle="true"/>
            </div>
        </div>
    </div>
</template>

<script>
    import { Carousel3d, Slide } from 'vue-carousel-3d';
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import $ from 'jquery'
    import ProductItem from '@/components/products/items/Item'
    import ProductItemBox from '@/components/products/items/ItemBox'
    import classApi from '@/api/class'
    import advertApi from '@/api/advert'
    import advancedSearchMixin from '@/mixins/advancedSearch'
    import userMixin from '@/mixins/user'
    import _ from 'lodash'

    export default {
        mixins: [advancedSearchMixin, userMixin],
        data() {
            return {
                h2title: {
                    featured: '精選區',
                    shelves: '新上架',
                    popular: '熱門區',
                    trailer: '預告區',
                },
                // 廣告區
                BannerCarouselStyle: {
                    Width: 0,
                    Height: 0
                },
                homeCarousel: [],
                // 精選區
                swiperOption: {
                    autoplay:true,
                    slidesPerView: 3,
                    spaceBetween: 30,
                    slidesPerGroup: 3,
                    loop: false,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    breakpoints: {
                        1920: {
                            spaceBetween: 10
                        },
                        1024: {
                            slidesPerView: 2,
                            slidesPerGroup: 2,
                            spaceBetween: 20
                        },
                        414: {
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            spaceBetween: 10,
                        }
                    }
                },
                swiperDom: [],
                productShelves: [],
                productPopular: [],
                productTrailer: [],
                currentSlideIndex: 0,
                disable3d: false,
            }
        },
        components: {
            Carousel3d,
            Slide,
            swiper,
            swiperSlide,
            ProductItem,
            ProductItemBox,
        },
        computed: { // 儲存資料,變數
            // 儲存methods事件後出來的結果/狀態
            slideout() {
                return this.$parent.slideout;
            },
            homeCarousels() {
                return this.homeCarousel.map((carousel) => {
                    return {
                        title: carousel.Title,
                        text: carousel.Title,
                        src: carousel.ImageUrl,
                        ImageLink: carousel.ImageLink,
                    };
                });
            },
        },
        created() {
            window.addEventListener('resize', this.BannerCarouselHandleResize);
            this.rwdDisable3d()
            this.getHomeCarousel();
            this.getQueryFeatured();
            this.getQueryNewHotPreparation();
            this.createMetaTag();
        },
        destroyed() {
            window.removeEventListener('resize', this.BannerCarouselHandleResize);
            const metaTags = document.querySelectorAll('meta[property^="og:"]');
            metaTags.forEach((metaTag) => {
                metaTag.parentNode.removeChild(metaTag);
            });
        },
        methods: {
            rwdDisable3d() {
                $(document).ready(()=>{
                let $window = $(window).width()
                    if( $window <= 767 ) {
                        this.disable3d = true
                    } else {
                        this.disable3d = false
                    }
                })
            },
            onBeforeSlideChange(index) {
                this.currentSlideIndex = index;
            },
            initUser() {
                this.getQueryFeatured();
                this.getQueryNewHotPreparation();
            },
            initAdvancedSearch() {
                this.getQueryFeatured();
                this.getQueryNewHotPreparation();
            },
            getHomeCarousel() {
                advertApi.homeCarousel((data) => {
                    this.homeCarousel = data ? data : [];
                    this.$nextTick(() => {
                        this.BannerCarouselHandleResize();
                    });
                });
            },
            getQueryFeatured() {
                this.swiperDom = [];
                classApi.queryFeatured({}, (data) => {
                    this.swiperDom = data ? data : [];
                });
            },
            getQueryNewHotPreparation () {
                this.productShelves = [];
                this.productPopular = [];
                this.productTrailer = [];
                classApi.queryNewHotPreparation({}, (data) => {
                    let StoreShelves = _.get(data, 'StoreShelves', []);
                    let Hot = _.get(data, 'Hot', []);
                    let Trailer = _.get(data, 'Trailer', []);

                    this.productShelves = StoreShelves ? StoreShelves : [];
                    this.productPopular = Hot ? Hot : [];
                    this.productTrailer = Trailer ? Trailer : [];
                });
            },
            // 阻止 Slideout 滑動 與 Vue-carousel-3d 衝突 start
            touchStart() {
                this.slideout.disableTouch();
            },
            touchEnd() {
                this.slideout.enableTouch();
            },
            // 阻止 Slideout 滑動 與 Vue-carousel-3d 衝突 end
            // Banner區 視窗更動時執行
            BannerCarouselHandleResize() {
                let $C3S = $('.banner .carousel-3d-slide'),
                    $C3SImgBox = $C3S.find('.img_box'),
                    $C3SImg = $C3SImgBox.children(),
                    SWidth = $C3SImg.width(),
                    SHeight = $C3SImg.height()
                console.log(SWidth)
                // 將套件同步於CSS IMGBOX
                this.BannerCarouselStyle.Width = SWidth
                this.BannerCarouselStyle.Height = SHeight + 20 // padding
            },
            createMetaTag() {
                // Create new meta tags
                const metaImage = document.createElement('meta');
                metaImage.setAttribute('property', 'og:image');
                metaImage.setAttribute('content', 'https://cdn.hola.com.tw/_ui/responsive/theme-trplus/app/images/mobile/index/hola-2023-revision-og.png?1692747001000');
                document.head.appendChild(metaImage);

                const metaTitle = document.createElement('meta');
                metaTitle.setAttribute('property', 'og:title');
                metaTitle.setAttribute('content', 'HOLA 和樂家居｜體驗生活美學');
                document.head.appendChild(metaTitle);

                const metaDescription = document.createElement('meta');
                metaDescription.setAttribute('property', 'og:description');
                metaDescription.setAttribute('content', 'HOLA提供從下廚到上桌、舒壓到好眠、共聚到休憩3大生活風格美學體驗課程，打造在家更享受的居家生活體驗');
                document.head.appendChild(metaDescription);
            },
        },
    }
</script>
<style>
.banner .current .img_box img {
    object-fit: fill !important;
}
</style>
